import "./UserMenu.scss";

import React, {useCallback, useContext, useMemo} from "react";
import {Avatar, Card, Dropdown} from "antd";
import {UserOutlined, LogoutOutlined} from "@ant-design/icons";
import {GlobalContext} from "@tools/globalContext";
import {LOCALSTORAGE} from "@tools/constants";
import useApi from "@hooks/useApi"
import {setStorage} from '@tools/localStorage';
import {useTranslation} from "react-i18next";
import {imageUrl} from "@tools/imageUrl"
import useLinkGenerator from "@extension/hooks/useLinkGenerator"
import {useNavigate} from "react-router-dom";

const UserMenu : React.FC<{negative?: boolean}> = (props) => {
    const { user, userMenuConfig } = useContext(GlobalContext);
    const {api} = useApi({config: []})
    const {t} = useTranslation()
    const {userLink} = useLinkGenerator()
    const navigate = useNavigate()

    const onMenuSelect = useCallback(async data => {
        if (data.key === "logout") {
            const dbRes = await api.user.logoutUser({})
            if(dbRes.data?.success) {
                setStorage(LOCALSTORAGE.TOKEN, "");
                setStorage(LOCALSTORAGE.USER, "");
                setStorage(LOCALSTORAGE.USERINDEX, "");
                window.location.href = process.env.PUBLIC_URL || "/"
            }
        }
        if (data.key === "profile") {
            const link = userLink(user)
            navigate(link as string)
        }
    }, [api])

    const menu = useMemo(() => {
        return  {
            items : [
                (!userMenuConfig || userMenuConfig.showProfile) ? {key: "profile", icon: <UserOutlined />, label: t("userMenu:profile")} : null,
                {key: "logout", icon: <LogoutOutlined />, label: t("userMenu:logout"), danger: true}
            ].filter(i => i),
            onClick: onMenuSelect
        }
    }, [userMenuConfig])


    return <Dropdown menu={menu}>
        <Card.Meta
            className={`userIndicator${props.negative ? " negative" : ""}`}
            avatar={<Avatar className="userImage" icon={<UserOutlined/>} src={imageUrl(user.image)}/>}
            title={user.name}
        />
    </Dropdown>
}

export default UserMenu
